import { createAction } from '@reduxjs/toolkit';
import { LoginData, LoginResponse, RequestError } from 'types';
import { createActionWithCallback } from '../utils';

export interface LoginCredentials {
  userName: string;
  password: string;
}

export const login = createAction('auth/login', (credentials: LoginCredentials) => ({
  payload: undefined,
  meta: credentials,
}));

export const checkLoginAction = createActionWithCallback<LoginResponse, Error>()('auth/checkLoginAction');

export const logged = createAction('auth/logged', (data?: LoginData, error?: RequestError) => ({
  payload: error || data,
  error: Boolean(error),
}));

export const logout = createAction('auth/logout');

export const logouted = createAction('auth/logouted', (error?: RequestError) => ({
  payload: error,
  error: Boolean(error),
}));

export const setUserName = createAction('auth/login-credentials', (userName: string) => ({
  payload: userName,
}));

export const setIsLoginExpired = createAction('auth/login-expired', (isLoginExpired: boolean | undefined) => ({
  payload: isLoginExpired,
}));

export default {
  logout,
  logouted,
  login,
  checkLoginAction,
  setUserName,
  setIsLoginExpired,
};
